// extracted by css-extract-rspack-plugin
export default {"loginWellWrapper":"_6f155a9d","loginWell":"_d4e6556e","hasMessage":"_3a6a0d4e","dibsLogo":"_9f9fed68"};